export default function demoListItemDirective() {
  return {
    template: require('./demo-list-item.html'),
    restrict: 'E',
    controller: 'DemoListItemController',
    controllerAs: 'demoListItemVM',
    bindToController: true,
    replace: true,
    scope: {
      listItem: '=',
      isChild: '=',
    },
  };
}
